<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Calculation Options</h1>
    <p>Some occupational pension schemes allow pension to only be calculated on earnings between certain thresholds.</p>
    <p>Please indicate if your scheme has any specific calculation options.</p>

    <div class="cell small-6">
        <form class="fieldset" @submit.prevent> 
          <label class="custom-check">
            <input
              type="checkbox"
              v-model="formData.isCalculatedBetweenTheLELandUEL"
            >Pension is calculated on earnings between the Lower Earnings Limit (LEL) and Upper Earnings Level (UEL)<span class="checkmark"></span>
          </label> 
          <label class="custom-check">
            <input
              type="checkbox"
              v-model="formData.isCalculatedOnEarningsAboveTheUEL"
            >Pension is calculated on earnings above the Upper Earnings Level (UEL)<span class="checkmark"></span>
          </label> 
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref(null)

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>